var _ImageSkeletonDescriptor_domElem;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import React from 'react';
import { Skeleton } from '@gravity-ui/uikit';
import { cn } from '../../../../classname';
import { ReactWidgetDescriptor } from '../../WidgetDecoration';
import './skeleton.css';
const b = cn('image-skeleton');
export class ImageSkeletonDescriptor extends ReactWidgetDescriptor {
    constructor(initPos, size) {
        super(initPos, 'image_skeleton');
        _ImageSkeletonDescriptor_domElem.set(this, void 0);
        __classPrivateFieldSet(this, _ImageSkeletonDescriptor_domElem, document.createElement('span'), "f");
        __classPrivateFieldGet(this, _ImageSkeletonDescriptor_domElem, "f").classList.add(b());
        if (size) {
            __classPrivateFieldGet(this, _ImageSkeletonDescriptor_domElem, "f").style.setProperty('--img-skeleton-width', size.width);
            __classPrivateFieldGet(this, _ImageSkeletonDescriptor_domElem, "f").style.setProperty('--img-skeleton-height', size.height);
        }
    }
    get pos() {
        var _a, _b;
        return (_b = (_a = this.getPos) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : this.initPos;
    }
    getDomElem() {
        return __classPrivateFieldGet(this, _ImageSkeletonDescriptor_domElem, "f");
    }
    renderReactElement() {
        return React.createElement(Skeleton, { className: b('skeleton') });
    }
}
_ImageSkeletonDescriptor_domElem = new WeakMap();
